import { useContext } from 'react';
import PortfolioItemContext from '../../../../PortfolioItemContext';
import {
  type RubricsPortfolio,
  type SetComplexImmerStateAction,
} from '@/lib/types';

// Mimicking the rubrics portfolio is necessary to make challenge/task rubrics
// work
const useMimicRubricsPortfolio = (): [
  RubricsPortfolio,
  SetComplexImmerStateAction<RubricsPortfolio>,
] => {
  const { portfolioItem, setPortfolioItem } = useContext(PortfolioItemContext);

  const rubricsPortfolio = portfolioItem.rubrics;

  const setRubricsPortfolio = (
    stateUpdateFunction: (oldState: RubricsPortfolio) => void,
  ) => {
    setPortfolioItem(portfolioItem => {
      stateUpdateFunction(portfolioItem.rubrics);
    });
  };

  return [rubricsPortfolio, setRubricsPortfolio];
};

export default useMimicRubricsPortfolio;
